<div class="delete-order-dialog-container">
    <div class="delete-order-dialog-header-container">
        <div>  <p class="delete-order-dialog-header-text delete-order-section-headers">DELETE DRAFT?</p></div>
        <div><p class="delete-order-dialog-sub-heading">You are about to delete this draft, are you sure?</p></div>
    </div>

    <div class="delete-order-btn-dialog-container">

        <button class="cancel-delete-order-dialog-btn" mat-flat-button type="button" (click)="cancelClearingItems()">
            <div class="cancel-delete-order-btn-content">
                <span><p class="cancel-delete-order-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="delete-order-btn" mat-flat-button type="button"
                (click)="deleteOrder()">
            <div class="delete-order-btn-content">
                <span><p class="delete-order-btn-text">DELETE DRAFT</p></span>
            </div>
        </button>
    </div>

</div>


